import { render, staticRenderFns } from "./VeHrKaoqinPerson.vue?vue&type=template&id=10d20496&scoped=true"
import script from "./VeHrKaoqinPerson.vue?vue&type=script&lang=js"
export * from "./VeHrKaoqinPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d20496",
  null
  
)

export default component.exports